




import Vue, { PropType } from 'vue';
// @ts-ignore
import vegaEmbed, { VisualizationSpec, Result, EmbedOptions, vega, vegaLite, Actions } from 'vega-embed';
import { TopLevelUnitSpec } from 'vega-lite/build/src/spec/unit';

export default Vue.extend({
  name: 'VueVegaEmbed',
  props: {
    spec: {
      type: Object as PropType<TopLevelUnitSpec>,
      required: true,
    },
    width: [Number, String],
    height: [Number, String],
    actions: {
      type: Object as PropType<Actions>,
    },
  },
  data() {
    return {
      result: null as any,
    };
  },
  computed: {
    readySpec(): TopLevelUnitSpec {
      const spec = { ...this.spec };
      if (this.width) {
        if (typeof this.width === 'number') {
          spec.width = this.width;
        } else if (this.width === 'auto') {
          spec.width = 'container';
        }
      }
      if (this.height) {
        if (typeof this.height === 'number') {
          spec.height = this.height;
        } else if (this.height === 'auto') {
          spec.height = 'container';
        }
      }
      spec.width = 'container';
      return spec;
    },
    vegaActions(): Actions | boolean {
      return this.actions || false;
    },
  },
  mounted() {
    this.draw();
  },
  watch: {
    spec() {
      this.draw();
    },
  },
  methods: {
    async draw() {
      this.result = await vegaEmbed(this.$refs.container as HTMLDivElement, this.readySpec, { actions: this.vegaActions, renderer: 'svg' });
    },
  },
});
